import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  workFilter: [],
};

 const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      state.workFilter = action.payload;
    },
  },
});

export const { updateFilter } = filterSlice.actions;
export default filterSlice.reducer;
